module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-row.76fa4659.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/BattleList/images/divider-row.png
// module id = 3211
// module chunks = 11